// Custom hook for ResetPassword page logic
import { Form } from 'antd';
import { z } from 'zod';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMessage } from '@context/MessageProvider';
import { resetPasswordSchema } from '@validators/outside.schema';
import { useResetPasswordMutation } from './useAuthMutations';

export const useResetPassword = () => {
    const [form] = Form.useForm();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const resetMutation = useResetPasswordMutation();

    const email = searchParams.get('email');
    const otp = searchParams.get('otp');

    const onFinish = async (values) => {
        if (resetMutation.isPending) return;
        if (!email || !otp) {
            showMessage('error', 'Email and OTP are required');
            return;
        }

        try {
            const parsedValues = resetPasswordSchema.parse(values);
            await resetMutation.mutateAsync({
                email,
                otp,
                newPassword: parsedValues.password,
            });
            navigate('/sign-in');
        } catch (error) {
            if (error instanceof z.ZodError) {
                const fieldErrors = {};
                error.errors.forEach((err) => {
                    fieldErrors[err.path[0]] = err.message;
                });
                form.setFields(
                    Object.keys(fieldErrors).map((field) => ({
                        name: field,
                        errors: [fieldErrors[field]],
                    })),
                );
            }
        }
    };

    return {
        form,
        loading: resetMutation.isPending,
        email,
        otp,
        onFinish,
    };
};
